import { render, staticRenderFns } from "./viewone.vue?vue&type=template&id=bc04f6da&scoped=true&"
import script from "./viewone.vue?vue&type=script&lang=js&"
export * from "./viewone.vue?vue&type=script&lang=js&"
import style0 from "./viewone.vue?vue&type=style&index=0&id=bc04f6da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc04f6da",
  null
  
)

export default component.exports